import * as React from "react";
import { DocumentTextIcon, FolderIcon } from "@heroicons/react/24/outline";
import { ClipboardIcon } from "lucide-react";
import { toDefaultDateFormat } from "@/helpers/dates";
import { Button } from "@/components/ui/button";
import { Item } from "@/types/fse";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";
import { useNavigate } from "react-router";

interface Props {
  item: Item;
  businessReport: BusinessReport;
}

export const BusinessReportSelectFileContentRow: React.FC<Props> = ({ item, businessReport }) => {
  const navigate = useNavigate();
  const [setIsLoading, setSetIsLoading] = React.useState(false);

  const handleOnClick = () => {
    navigate(`/reports/${item.id}?businessReport=${businessReport.id}`);
    setSetIsLoading(true);
  };
  return (
    <div className="relative mb-1 flex flex-col items-start gap-4 border border-dotted border-custom-blue-100 p-4 md:flex-row md:items-center md:p-6">
      <div className="relative w-full md:w-1/2 lg:w-7/12">
        <div className="flex items-center">
          {item.type === "folder" ? (
            <FolderIcon className="mr-2 h-5 w-5 text-yellow-500" />
          ) : (
            <DocumentTextIcon className="mr-2 h-5 w-5 text-blue-500" />
          )}
          <span className="truncate font-medium">{item.name}</span>
        </div>
        <div className="mt-1 flex flex-wrap items-center text-xs text-gray-500">
          <span className="mr-2">{toDefaultDateFormat(item.created_at)}</span>
        </div>
      </div>
      <div className="mt-2 flex w-full flex-wrap items-center justify-start gap-2 md:mt-0 md:w-1/2 md:justify-end lg:w-5/12">
        <Button
          disabled={setIsLoading}
          variant="secondary"
          size="sm"
          className="w-full text-xs sm:w-auto"
          type="button"
          onClick={handleOnClick}
        >
          <div className="flex content-between align-middle">
            <ClipboardIcon className="mr-1 h-4 w-4" />
            {setIsLoading ? "Loading..." : "SnapShot"}
          </div>
        </Button>
      </div>
    </div>
  );
};
